(function() {
  'use strict';

  // Move modal to body so it escapes any parent stacking context
  const modalEl = document.getElementById('sb-fabric-modal');
  if (modalEl && modalEl.parentElement !== document.body) {
    document.body.appendChild(modalEl);
  }

  const modal = document.getElementById('sb-fabric-modal');
  if (!modal) return;

  const openers = document.querySelectorAll('[data-sb-fabric-open]');
  const closers = modal.querySelectorAll('[data-sb-fabric-close]');
  const tabs = modal.querySelectorAll('.sb-fabric-modal__tab');
  const panes = modal.querySelectorAll('.sb-fabric-modal__pane');
  let lastTrigger = null;

  function openModal(e) {
    lastTrigger = e.currentTarget;
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    const closeBtn = modal.querySelector('.sb-fabric-modal__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeModal() {
    modal.hidden = true;
    document.body.style.overflow = '';
    if (lastTrigger) lastTrigger.focus();
  }

  function switchTab(targetId) {
    tabs.forEach(t => {
      const active = t.dataset.fabricTarget === targetId;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    panes.forEach(p => {
      p.classList.toggle('is-active', p.dataset.fabricPane === targetId);
    });
  }

  openers.forEach(o => o.addEventListener('click', openModal));
  closers.forEach(c => c.addEventListener('click', closeModal));

  tabs.forEach(t => {
    t.addEventListener('click', () => switchTab(t.dataset.fabricTarget));
  });

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && !modal.hidden) closeModal();
  });
})();